import { Table } from '@tanstack/react-table';
import { ComponentProps } from 'react';
import { CheckboxLabeled } from '../../../../../design-system/checkbox/checkbox-labeled';
import { cn } from '../../../../../utils/cn';

type TableFilterSelectAllProps<TData> = Omit<ComponentProps<typeof CheckboxLabeled>, 'checked' | 'label'> & {
  table: Table<TData>;
};

export const TableFilterSelectAll = <TData,>({ table, ...props }: TableFilterSelectAllProps<TData>) => {
  const isAllRowsSelected = table.getIsAllRowsSelected();
  const isSomeRowsSelected = table.getIsSomeRowsSelected();
  const isIndeterminate = isSomeRowsSelected && !isAllRowsSelected;

  return (
    <CheckboxLabeled
      {...props}
      checked={isIndeterminate ? 'indeterminate' : isAllRowsSelected}
      label="Select all"
      labelClassName={cn('text-xs leading-5 font-medium tracking-tight text-black', {
        'text-muted-foreground': props.disabled,
      })}
      onCheckedChange={(value) => {
        table.toggleAllRowsSelected(!!value);
      }}
    />
  );
};
